import ContainerMaxWidthXl from '@deltek/specification-client/core/Surfaces/ContainerMaxWidthXl'
import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import { AppBar } from '@material-ui/core'
import { processEnv } from 'components/configuration/environmentVariables'
import { BulkAddElementInput } from 'models/getProjectElementNodesInput'
import React from 'react'
import { useBetaWorkspaceFlag } from 'shared/useBetaWorkspaceFlag'
import { WorkspaceActionBarContext } from '../WorkspaceActionBarContext'
import BulkAddBarRightSection from './BulkAddBarRightSection'
import { useBulkAddBarStyles } from './bulkAddBarStyles'
import BulkAddBarLeftSection from './BulkAddLeftSection'

export interface BulkAddBarStyleProps {
    isBetaWorkspaceToggleEnabled?: boolean
}
export interface BulkAddBarProps extends BulkAddBarStyleProps {
    resetBulkAddElements: () => void
    addBulkAddItemsToProject: () => void
    selectedBulkAddElements?: BulkAddElementInput[]
}

const BulkAddBar = ({
    selectedBulkAddElements,
    resetBulkAddElements,
    addBulkAddItemsToProject,
}: BulkAddBarProps) => {
    const { currentState } = React.useContext(WorkspaceActionBarContext)
    // hook to check if the beta workspace is enabled using url params
    const { isBetaWorkspaceEnabled } = useBetaWorkspaceFlag()
    const isBetaWorkspaceToggleEnabled =
        (processEnv?.REACT_APP_ShowRedesignedEditorToggle === '1' ||
            isBetaWorkspaceEnabled) &&
        currentState?.showHideStates?.betaWorkspace
    const classes = useBulkAddBarStyles({ isBetaWorkspaceToggleEnabled })
    const bulkAddBarRef: React.RefObject<HTMLDivElement> = React.useRef(null)

    return (
        <AppBar
            elevation={0}
            position="relative"
            className={classes.searchBarContainer}
            ref={bulkAddBarRef}
            data-testid="bulkAddBar"
        >
            <ContainerMaxWidthXl>
                <GridContainer justifyContent="space-between">
                    <BulkAddBarLeftSection
                        selectedBulkAddElements={selectedBulkAddElements}
                        addBulkAddItemsToProject={addBulkAddItemsToProject}
                        isBetaWorkspaceToggleEnabled={
                            isBetaWorkspaceToggleEnabled
                        }
                    />
                    <BulkAddBarRightSection
                        resetBulkAddElements={resetBulkAddElements}
                        isBetaWorkspaceToggleEnabled={
                            isBetaWorkspaceToggleEnabled
                        }
                    />
                </GridContainer>
            </ContainerMaxWidthXl>
        </AppBar>
    )
}

export default BulkAddBar
